import React from 'react';
import BigCalendar from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';

class EventsCalendar extends React.Component {
   handleEventSelected(event) {
      this.props.handleEventSelected(event);
   }

   onNavigate = (value) => {
      this.props.keepCalendarDateState(value);
   }

   onView = (value) => {
      this.props.keepCalendarViewState(value);
   }
   render() {
      let formats = {
         eventTimeRangeFormat: ({start, end}, culture, local) => local.format(start, 'HH:mm', culture),
         agendaTimeRangeFormat: ({start, end}, culture, local) => local.format(start, 'HH:mm', culture),
         timeGutterFormat: 'HH:mm',
      }

      return (
         <BigCalendar
            onNavigate ={this.onNavigate.bind(this)}
            onView = {this.onView.bind(this)}
            className={"calendar"}
            popup={true}
            events={this.props.data}
            defaultDate={this.props.date}
            defaultView = {this.props.view}
            formats={formats}
            onSelectEvent = {this.handleEventSelected.bind(this)}
         />
      )
   }
}

export default EventsCalendar;



// WEBPACK FOOTER //
// ./src/pages/myEvents/eventsCalendar/eventsCalendar.component.js